import { render, staticRenderFns } from "./global.vue?vue&type=template&id=bf1b5808"
import script from "./global.vue?vue&type=script&lang=js"
export * from "./global.vue?vue&type=script&lang=js"
import style0 from "./global.vue?vue&type=style&index=0&id=bf1b5808&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports